import { useCallback, useContext } from 'react';
import STORE from 'store';

import AccountPickerContext from 'contexts/AccountPickerContext';
import BoardContext from 'contexts/BoardContext';
import CurrentUserContext from 'contexts/CurrentUserContext';
import isPerformanceBoard from 'isPerformanceBoard';
import getTimeStamp from 'getTimeStamp';

const useUpdateGeneral = () => {
  const currentUser = useContext(CurrentUserContext);
  const { selectedAccountId } = useContext(AccountPickerContext);
  const { board } = useContext(BoardContext);

  const updateGeneral = useCallback(
    ({ draftBoard }: { draftBoard: PerformanceBoardTypes.Board }) => {
      if (!isPerformanceBoard(board)) {
        return;
      }

      const newBoard: PerformanceBoardTypes.Board = {
        ...draftBoard,
        updatedBy: currentUser.id,
        updatedOn: getTimeStamp(),
      };
      STORE.contentDistributions
        .getPerformanceBoardsRef({
          accountId: selectedAccountId,
        })
        .doc(newBoard.id)
        .set(newBoard);
    },
    [board, currentUser.id, selectedAccountId],
  );

  return updateGeneral;
};

export default useUpdateGeneral;
